module.exports = __webpack_public_path__ + "assets/images/shimmerShapeIcon.fd95f439de1cebbc721bf970b8824897.svg";